module.exports = __webpack_public_path__ + "static/media/no-matches-found.99cc3d71.webp";